<template>
  <div class="bg1" ref="setH">
    <div class="manageBox">
      <div class="searchBox">
        <ul>
          <li>
            <el-radio-group v-model="search.shareSystem" size="small" @change="shareSystemChange">
              <el-radio-button :label="0">待审核</el-radio-button>
              <el-radio-button :label="1">已通过</el-radio-button>
              <el-radio-button :label="2">已拒绝</el-radio-button>
            </el-radio-group>
          </li>
          <li>
            <em>基础筛选：</em>
            <!-- 选择学段 -->
            <template v-if="search.shareSystem==1">
              <el-select v-model="searchSuc.sectionId" placeholder="选择学段" style="width: 120px" size="small" clearable @change="sectionChange">
                <el-option v-for="item in dataSuc.sectionList" :key="item.node" :label="item.text" :value="item.node"></el-option>
              </el-select>
              <!-- 选择年级 -->
              <el-select v-model="searchSuc.gradeId" placeholder="选择年级" style="width: 120px" size="small" clearable>
                <el-option v-for="item in dataSuc.gradeList" :key="item.node" :label="item.text" :value="item.node"></el-option>
              </el-select>
              <!-- 学科 -->
              <el-select v-model="searchSuc.subjectId" placeholder="选择学科" style="width: 120px" size="small" clearable @change="subjectChange">
                <el-option v-for="item in dataSuc.subjectList" :key="item.node" :label="item.text" :value="item.node"></el-option>
              </el-select>
              <el-select v-model="searchSuc.versionId" placeholder="选择版本" style="width: 120px" size="small" @change="versionChange">
                <el-option v-for="item in dataSuc.versionList" :key="item.node" :label="item.text" :value="item.node"></el-option>
              </el-select>
              <!-- 册次 -->
              <el-select v-model="searchSuc.volumeId" placeholder="选择册次" style="width: 120px" size="small" clearable>
                <el-option v-for="item in dataSuc.volumeList" :key="item.node" :label="item.text" :value="item.node"></el-option>
              </el-select>
            </template>
            <template v-else>
              <el-input v-model="search.sectionName" placeholder="请输入学段" style="width: 150px" size="small" clearable></el-input>
              <el-input v-model="search.subjectName" placeholder="请输入学科" style="width: 150px" size="small" clearable></el-input>
              <el-input v-model="search.gradeName" placeholder="请输入年级" style="width: 150px" size="small" clearable></el-input>
            </template>

          </li>
          <li>
            <em>视频名称：</em>
            <el-input v-model="search.resourceName" placeholder="请输入视频名称" style="width: 460px" size="small" clearable></el-input>
          </li>
          <li v-if="search.shareSystem==0">
            <em>下载状态：</em>
            <el-select v-model="search.downloadStatus" placeholder="请选择下载状态" style="width: 460px" size="small" clearable>
              <el-option label="已下载" :value="1"></el-option>
              <el-option label="下载中" :value="2"></el-option>
              <el-option label="下载失败" :value="3"></el-option>
            </el-select>
          </li>
          <li v-if="search.shareSystem==1">
            <em>视频状态：</em>
            <el-select v-model="searchSuc.shareSystem" placeholder="请选择视频状态" style="width: 460px" size="small" clearable>
              <el-option label="上架" :value="1"></el-option>
              <el-option label="下架" :value="3"></el-option>
            </el-select>
          </li>
          <li>
            <em>选择时间：</em>
            <el-date-picker v-model="search.startTime" :picker-options="pickerOptionsStart" value-format="yyyy-MM-dd" size="small" type="date"
                            placeholder="选择日期"></el-date-picker>
            <font style="padding: 0 10px">至</font>
            <el-date-picker v-model="search.endTime" :picker-options="pickerOptionsEnd" value-format="yyyy-MM-dd" size="small" type="date" placeholder="选择日期"
                            @change="endTimeChange">
            </el-date-picker>
            <el-button type="primary" @click="getDataList" size="small">查询</el-button>
            <el-button plain @click="handleReset" size="small">重置</el-button>
            <el-button type="danger" v-if="search.shareSystem == 0" @click="handleDownload()" size="small">重新下载失败视频</el-button>
            <el-button type="primary" v-if="search.shareSystem == 1" @click="handleDel('',true)" size="small">批量上架</el-button>
            <el-button type="danger" v-if="search.shareSystem == 1" @click="handleDel('',false)" size="small">批量下架</el-button>
          </li>
        </ul>
      </div>

      <div class="contentBox">
        <div class="bd ys4" style="min-height: 520px">
          <ul v-if="tableData.length > 0">
            <!-- 根据is-disabled样式隐藏选择框 -->
            <el-checkbox-group v-model="checkList" :disabled="search.shareSystem != 1">
              <li v-for="(d, i) in tableData" :key="i">
                <el-checkbox :label="d">
                  <div class="icon">
                    <!-- <svg class="icon" aria-hidden="true">
                      <use :xlink:href="'#icontbd' + d.fileType"></use>
                    </svg> -->
                    <el-image :src="require('@/assets/img/cancel.png')" fit="contain" v-if="search.shareSystem==2">
                    </el-image>
                    <el-image :src="d.coverUrl?uploadUrl+d.coverUrl:require('@/assets/img/vedioCover.png')" fit="contain" v-else></el-image>
                  </div>
                  <div class="title">
                    <h5 v-if="search.shareSystem == 2">{{ d.resourceName }}</h5>
                    <h5 @click="yulan(d, '',false,true)" v-else>{{ d.resourceName }}</h5>
                    <span class="catalog">
                      <i class="ka">{{ d.sectionName }}</i>
                      <i v-if="search.shareSystem == 1">{{ formatSnapshot(d) }}</i>
                      <i v-else>{{d.gradeName}} {{d.subjectName}}</i>
                    </span>
                    <span class="attribute">时间：{{d.createTime}}</span>
                    <span class="attribute">大小：{{unit(d.fileSize)}}</span>
                  </div>
                  <div class="operate">
                    <el-button type="primary" v-if="search.shareSystem == 0&&d.downloadStatus!=1" @click="handleDownload(d)" :disabled="d.downloadStatus==2"
                               size="small" style="width: 120px">{{d.downloadStatus==2?'下载中':'下载'}}
                    </el-button>
                    <el-button type="primary" v-if="search.shareSystem == 0&&d.downloadStatus==1" @click="handlePass(d,'add')" size="small"
                               style="width: 120px">
                      通过并设置目录</el-button>
                    <el-button type="danger" v-if="search.shareSystem == 0" @click="handleReject(d)" size="small" style="width: 120px">拒绝</el-button>
                    <el-popover v-if="search.shareSystem == 2" placement="left" title="拒绝详情" width="300" trigger="hover">
                      <div>
                        <p>审核人: {{d.approvalUserName}}</p>
                        <p>审核时间: {{d.approvalRejectTime}}</p>
                        <p>拒绝原因: <span>{{d.approvalReason}}</span></p>
                      </div>
                      <el-button slot="reference" size="small" style="width: 120px">拒绝记录</el-button>
                    </el-popover>

                    <el-button type="primary" v-if="search.shareSystem == 1" @click="handlePass(d,'edit')" size="small" style="width: 120px">变更目录</el-button>
                    <el-button type="text" v-if="search.shareSystem == 1&& d.shareSystem==3" @click="handleDelete(d)" size="small"
                               style="width: 120px;color:#F56C6C">删除
                    </el-button>
                    <el-button type="text" v-if="search.shareSystem == 1" @click="handleSetCover(d)" size="small" style="width: 120px">设置封面</el-button>
                    <el-button type="text" v-if="search.shareSystem == 1 && d.shareSystem==3" @click="handleDel(d.resourceId,true)" size="small"
                               style="width: 120px;color:#67c23a">上架</el-button>
                    <el-button type="text" v-if="search.shareSystem == 1  && d.shareSystem!=3" @click="handleDel(d.resourceId,false)" size="small"
                               style="width: 120px">下架</el-button>

                  </div>
                </el-checkbox>
              </li>
            </el-checkbox-group>
          </ul>
          <div class="unusual" v-else><span class="pt320">暂无内容</span></div>
          <el-pagination :current-page.sync="search.page" @current-change="handleCurrentChange" @size-change="handleSizeChange" background
                         layout="total, sizes, prev, pager, next, jumper" :total="search.total" :page-size="search.size"></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog title="拒绝原因" :visible.sync="dialogVisible" width="30%">
      <!-- <em style="color: #f30; vertical-align: top">*</em> -->
      <el-input type="textarea" placeholder="请输入备注内容" :autosize="{ minRows: 4 }" v-model="rejectFormData.remark" maxlength="50" show-word-limit></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="handleRejectSubmit">确 定</el-button>
      </span>
    </el-dialog>

    <pass-and-catalog ref="refPassCatalog" @search="getDataList"></pass-and-catalog>
    <set-cover ref="refSetCover" @search="getDataList"></set-cover>
  </div>
</template>

<script>
import axios from "axios";
import yulanmix from "../../mixins/yulan";
import passAndCatalog from "./components/passAndCatalog.vue";
import setCover from "./components/setCover.vue";
export default {
  name: "examine",
  components: { passAndCatalog, setCover },
  data() {
    return {
      checkList: [],
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.search.endDate) {
            return time.getTime() > new Date(this.search.endDate).getTime();
          }
        },
      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.search.beginDate) {
            return (
              time.getTime() <
              new Date(this.search.beginDate).getTime() - 86400000
            );
          }
        },
      },
      dialogVisible: false,
      tabH: 0,
      search: {
        shareSystem: 0,
        fileType: "",
        resourceName: "",
        downloadStatus: "",
        sectionName: "",
        subjectName: "",
        gradeName: "",
        startTime: "",
        endTime: "",
        orderBy: "create_time",
        page: 1,
        size: 10,
        total: 0,
      },
      searchSuc: {
        shareSystem: "",
        sectionId: "",
        gradeId: "",
        subjectId: "",
        versionId: "",
        volumeId: "",
        resourceName: "",
      },
      dataSuc: {
        sectionList: [],
        gradeList: [],
        subjectList: [],
        versionList: [],
        volumeList: [],
      },
      tableData: [],
      pages: {
        pageIndex: 1,
        pageAll: 100,
        pageSize: 10,
      },
      rejectFormData: {
        resources: [{}], //视频id
        remark: "",
      },
      uploadUrl: "",
      previewUrl: "",
    };
  },

  mixins: [yulanmix],
  async mounted() {
    let parData = this.$route.params.parData;
    await this.getSection();
    if (parData) {
      this.search.sectionName = parData.sectionName;
      this.search.gradeName = parData.gradeName;
      this.search.subjectName = parData.subjectName;

      // if(parData.sectionName){
      //   this.searchSuc.sectionId = this.dataSuc.sectionList.find(item=>item.text==parData.sectionName).sectionId
      // }
      // await this.getGrade()
      // await this.getSubject()
      // if(parData.gradeName){
      //   this.searchSuc.gradeId = this.dataSuc.gradeList.find(item=>item.text==parData.gradeName).node
      // }
      // if(parData.subjectName){
      //   this.searchSuc.subjectId = this.dataSuc.subjectList.find(item=>item.text==parData.subjectName).node
      // }
    }
    this.$nextTick(() => {
      this.tabH = this.$refs.setH.clientHeight - 230;
    });

    this.getDataList();
    // this.getResourcesList();
    this.uploadUrl = window.sessionStorage.getItem("fileJavaServerUrl");
    this.previewUrl = window.sessionStorage.getItem("previewUrl");
  },
  methods: {
    handleDelete(data) {
      this.$confirm("是否删除该视频?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let param = {
          resources: [{ resourceId: data.resourceId, fileId: data.fileId }],
        };
        // /server/third/resource/approval/reject
        this.$ajax
          .post("/server/third/resource/approval/delete", param, {
            headers: {
              "Content-Type": "application/json",
            },
          })
          .then((res) => {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.getDataList();
            this.dialogVisible = false;
          });
      });
    },
    handleDownload(checkItem) {
      // if (this.checkList.length <= 0 && !checkItem) {
      //   return;
      // }
      let params = [];
      // if (checkItem) {
      //   params = [
      //     {
      //       resourceId: checkItem.resourceId,
      //       newestCloudRecordUrl: checkItem.newestCloudRecordUrl,
      //     },
      //   ];
      // } else {
      //   let paramsList = this.checkList.map((item) => {
      //     return {
      //       resourceId: item.resourceId,
      //       newestCloudRecordUrl: item.newestCloudRecordUrl,
      //     };
      //   });
      //   params = [...paramsList];
      // }
      this.$ajax
        .post("/server/sync/download/file", params, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          this.$message({
            type: "success",
            message: res,
          });
          this.getDataList();
        })
        .catch((err) => {
          // this.$message({
          //   type: "error",
          //   message: err,
          // });
        });
    },
    endTimeChange(val) {
      if (!this.search.startTime) {
        this.$message.warning("请先选择开始时间");
        this.search.endTime = "";
        return;
      }
      if (val) {
        let start = new Date(Date.parse(this.search.startTime));
        let end = new Date(Date.parse(val));
        if (end < start) {
          this.$message.warning("结束时间要大于开始时间");
          this.search.startTime = "";
          this.search.endTime = "";
          return;
        }
      }
    },
    handleReset() {
      this.search.fileType = "";
      this.search.resourceName = "";
      this.search.sectionName = "";
      this.search.subjectName = "";
      this.search.gradeName = "";
      this.search.startTime = "";
      this.search.endTime = "";
      this.search.orderBy = "create_time";
      this.search.page = 1;
      this.search.size = 10;
      this.search.total = 0;

      this.searchSuc.sectionId = "";
      this.searchSuc.gradeId = "";
      this.searchSuc.subjectId = "";
      this.searchSuc.versionId = "";
      this.searchSuc.volumeId = "";
      this.searchSuc.resourceName = "";
    },
    formatSnapshot(data) {
      let str = "";
      str += data.sectionName ? data.sectionName : "";
      str += data.subjectName ? " / " + data.subjectName : "";
      str += data.versionName ? " / " + data.versionName : "";
      str += data.volumeName ? " / " + data.volumeName : "";
      str += data.firstChapterName ? " / " + data.firstChapterName : "";
      str += data.secondChapterName ? " / " + data.secondChapterName : "";
      str += data.thirdChapterName ? " / " + data.thirdChapterName : "";
      str += data.fourthChapterName ? " / " + data.fourthChapterName : "";
      return str;
    },
    handleDel(resourceId, type) {
      if (this.checkList.length <= 0 && !resourceId) {
        return;
      }
      let params = [];
      if (resourceId) {
        params = [resourceId];
      } else {
        let resourceIdList = this.checkList.map((item) => item.resourceId);
        params = [...resourceIdList];
      }
      // /server/third/resource/approval/delete
      this.$ajax
        .post(
          type
            ? "/server/third/resource/approval/put/on/shelf"
            : "/server/third/resource/approval/take/down/shelf",
          params,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.getDataList();
          this.$message({
            type: "success",
            message: type ? "已上架!" : "已下架!",
          });
        });
      // this.$confirm("下架将永久删除视频文件, 是否继续?", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning",
      // }).then(() => {
      //   let params = [];
      //   if (resourceId) {
      //     params = [resourceId];
      //   } else {
      //     let resourceIdList = this.checkList.map((item) => item.resourceId);
      //     params = [...resourceIdList];
      //   }
      //   this.$ajax
      //     .post("/server/third/resource/approval/delete", params, {
      //       headers: {
      //         "Content-Type": "application/json",
      //       },
      //     })
      //     .then((res) => {
      //       this.getDataList();
      //       this.$message({
      //         type: "success",
      //         message: "下架成功!",
      //       });
      //     });
      // });
    },
    handleSetCover(data) {
      this.$refs.refSetCover.init(data);
    },
    /**
     * type add通过，edit变更目录
     */
    handlePass(data, type) {
      this.$refs.refPassCatalog.init(data, type);
    },
    handleReject(data) {
      this.dialogVisible = true;
      this.rejectFormData.resources[0].resourceId = data.resourceId;
      this.rejectFormData.resources[0].fileId = data.fileId;
    },
    handleRejectSubmit() {
      // if (this.rejectFormData.remark == "") {
      //   this.$message({
      //     message: "请填写拒绝原因",
      //     type: "warning",
      //   });
      //   return;
      // }
      this.$ajax
        .post("/server/third/resource/approval/reject", this.rejectFormData, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          this.$message({
            message: "已拒绝",
            type: "success",
          });
          this.rejectFormData.resources = [{}];
          this.rejectFormData.remark = "";
          this.getDataList();
          this.dialogVisible = false;
        });
    },
    unit(v) {
      let arr = ["B", "KB", "MB", "GB", "TB"];
      let i = 0;
      while (v > 1024) {
        i++;
        v = Math.floor((v * 100) / 1024) / 100;
      }
      return v + arr[i];
    },
    // 分页页码变动
    handleSizeChange(v) {
      this.search.size = v;
      this.search.page = 1;
      this.getDataList();
    },
    handleCurrentChange(v) {
      this.search.page = v;
      this.getDataList();
    },
    shareSystemChange() {
      this.checkList = [];
      this.handleReset();
      if (this.search.shareSystem == 0) {
        let parData = this.$route.params.parData;
        if (parData) {
          this.search.sectionName = parData.sectionName;
          this.search.gradeName = parData.gradeName;
          this.search.subjectName = parData.subjectName;
        }
      } else {
        this.search.sectionName = "";
        this.search.gradeName = "";
        this.search.subjectName = "";
        this.search.downloadStatus = "";
      }
      this.getDataList();
    },

    // 查询审核列表
    getDataList() {
      let urlLink =
        this.search.shareSystem === 1
          ? // ? "/server/third/resource/listByDate"
            "/server/third/resource/approval/list/audited"
          : `/server/third/resource/approval/list/by/status`;
      let params = null;
      if (this.search.shareSystem === 0) {
        params = {
          ...this.search,
          createStartDate: this.search.startTime,
          createEndDate: this.search.endTime,
        };
      } else if (this.search.shareSystem === 2) {
        params = {
          ...this.search,
          createStartDate: this.search.startTime,
          createEndDate: this.search.endTime,
          orderBy: "approval_reject_time",
        };
      } else {
        params = {
          ...this.searchSuc,
          resourceName: this.search.resourceName,
          startTime: this.search.startTime,
          endTime: this.search.endTime,
          page: this.search.page,
          size: this.search.size,
          total: this.search.total,
        };
      }
      this.$ajax.post(urlLink, params).then((res) => {
        res.list.forEach((item) => (item.fileType = 5));
        this.tableData = res.list;
        this.search.total = res.total;
      });
    },
    sectionChange() {
      console.log("change");
      this.searchSuc.gradeId = "";
      this.searchSuc.subjectId = "";
      this.searchSuc.versionId = "";
      this.searchSuc.volumeId = "";
      this.dataSuc.gradeList = [];
      this.dataSuc.subjectList = [];
      this.dataSuc.versionList = [];
      this.dataSuc.volumeList = [];
      if (this.searchSuc.sectionId) {
        this.getGrade();
        this.getSubject();
      }
    },

    subjectChange() {
      this.searchSuc.versionId = "";
      this.searchSuc.volumeId = "";
      this.dataSuc.versionList = [];
      this.dataSuc.volumeList = [];
      if (this.searchSuc.subjectId) this.getVersion();
    },
    versionChange() {
      this.searchSuc.volumeId = "";
      this.dataSuc.volumeList = [];
      if (this.searchSuc.versionId) this.getVolume();
    },

    // 获取学段
    async getSection() {
      let urlLink = `/common/catalog/load/section`;
      this.dataSuc.sectionList = await this.$ajax.post(urlLink);
    },
    // 获取年级
    async getGrade() {
      let urlLink = `/common/catalog/load/grade`;
      this.dataSuc.gradeList = await this.$ajax.post(urlLink, {
        sectionId: this.searchSuc.sectionId,
      });
    },
    // 获取学科
    async getSubject() {
      let urlLink = `/common/catalog/load/subject`;
      this.dataSuc.subjectList = await this.$ajax.post(urlLink, {
        sectionId: this.searchSuc.sectionId,
      });
    },
    // 获取版本
    getVersion() {
      let urlLink = `/common/catalog/load/version`;
      this.$ajax
        .post(urlLink, {
          sectionId: this.searchSuc.sectionId,
          subjectId: this.searchSuc.subjectId,
        })
        .then((res) => {
          this.dataSuc.versionList = res;
        });
    },
    // 获取册次
    getVolume() {
      let urlLink = `/common/catalog/load/volume`;
      this.$ajax
        .post(urlLink, {
          sectionId: this.searchSuc.sectionId,
          subjectId: this.searchSuc.subjectId,
          versionId: this.searchSuc.versionId,
        })
        .then((res) => {
          this.dataSuc.volumeList = res;
        });
    },
  },
};
</script>

<style scoped>
.contentBox >>> .el-checkbox__input.is-disabled{
  display: none;
}
.icon {
  /* margin-left: 20px; */
}
.icon > .el-image {
  width: 100%;
  height: 100%;
}
.title {
  /* width: 850px !important; */
}
.title > h5 {
  color: #333;
  cursor: pointer;
}
.operate {
  display: flex !important;
  flex-wrap: wrap;
  width: 160px !important;
}
.el-popover.el-popper > div > p > span {
  word-wrap: break-word;
}
.el-popover.el-popper > div > p {
  text-align: left;
}
</style>
<style>
.el-checkbox > .el-checkbox__input {
  margin-top: 0 !important;
}
.el-checkbox > .el-checkbox__label {
  display: flex;
  flex-grow: 1;
}
</style>



// WEBPACK FOOTER //
// src/page/audit/classExamine.vue